<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <AgrButton
          icon
          small
          v-on="on"
          @click="displayTooltip"
        >
          <v-icon :color="isDark ? 'primary' : 'secondary'">
            mdi-help-circle
          </v-icon>
        </AgrButton>
      </template>

      <span>{{ message }}</span>
    </v-tooltip>
    <v-snackbar
      v-if="($vuetify.breakpoint.mobile || $vuetify.breakpoint.tablet) && isOpenSnackbar"
      v-model="isOpenSnackbar"
      color="secondary"
    >
      <span class="texte white--text">{{ message }}</span>
    </v-snackbar>
  </div>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'BaseTooltipNoData',
  components: { AgrButton },
  props: {
    message: {
      type: String,
      required: true
    },
    isDark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenSnackbar: false
    }
  },
  methods: {
    displayTooltip () {
      this.isOpenSnackbar = !this.isOpenSnackbar
    }
  }
}
</script>
